export enum CommentListEnum {
  ALL = 'all',
  OPEN = 'open',
  FINISHED = 'finished'
}
